import {
  Box,
  BoxProps,
  CircularProgress,
  Modal,
  ModalProps,
} from "@mui/material";

interface RFModalProps extends ModalProps {
  boxProps?: BoxProps;
  isLoading?: boolean;
}

const RFModal = ({ boxProps, isLoading, ...modalProps }: RFModalProps) => {
  return (
    <div style={{ backgroundColor: "yellow" }}>
      <Modal
        {...modalProps}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          {...boxProps}
          {...(isLoading && {
            sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          })}
        >
          {isLoading ? <CircularProgress /> : modalProps.children}
        </Box>
      </Modal>
    </div>
  );
};

export default RFModal;
